import { useCallback, useMemo } from "react";

import { UniformSlot } from "@uniformdev/canvas-react";
import {
    FilterableGalleryLoaderProvider,
    type FilterableGalleryLoaderRegistration
} from "src/uniform/contexts/filterable-gallery-loader-context";

import { useBackfill } from "../../filterable-gallery/src/hooks/use-backfill";

import { getContentfulGalleryItems } from "./client-gql/fetch.ts";

import type { ContentfulGalleryDataType } from "./client-gql/types.ts";
import type { LoadAdditionalItems } from "../../filterable-gallery/src/types";

export type ContentType = ContentfulGalleryDataType;

export type ContentfulGalleryContainerProps = {
    contentType?: ContentType;
};

const ContentfulGalleryContainer = ({
    contentType = "productTemplate"
}: ContentfulGalleryContainerProps): JSX.Element => {
    const loadContentfulItems = useCallback<LoadAdditionalItems>(
        ({ loaded }) => getContentfulGalleryItems({ contentType, loaded }),
        [contentType]
    );

    const currentRegistration = useMemo<FilterableGalleryLoaderRegistration>(
        () => ({ loader: loadContentfulItems }),
        [loadContentfulItems]
    );

    const { extraItems } = useBackfill({
        seedCount: 0,
        loader: loadContentfulItems
    });

    return (
        <FilterableGalleryLoaderProvider
            currentRegistration={currentRegistration}
            extraItems={extraItems}
        >
            <UniformSlot name="content" />
        </FilterableGalleryLoaderProvider>
    );
};

export default ContentfulGalleryContainer;
